import axios from 'axios'
import {Response} from '@/domain/Common'
import env from '@//util/Env'

export default class QuestionnaireService {

  public static question(answer: string): Promise<Questionnaire> {
    return axios
      .get<Response<Questionnaire>>(
        `${env.ApiUrl}/public/portfolio/questionnaire?answer=${answer}`,
      )
      .then((res) => {
        return res.data.result
      })
  }
}

export interface Questionnaire {
  candidates: PMStrategyMini[]
  topix: Topix
}

export interface PMStrategyMini {
  code: string
  name: string
  'return': string
  risk: string
  activeReturn: string
  activeRisk: string
  description: string
  descriptionShort: string
}

export interface Topix {
  'return': string
  risk: string
  activeReturn: string
  activeRisk: string
}
